import { InfoIcon } from "@phosphor-icons/react/dist/ssr";
import classNames from "classnames";
export const MvarDerivedUnavailableNotice = ({
  message,
  className
}: {
  message: string;
  className?: string;
}) => <div className={classNames("flex items-start gap-2 bg-red-50 px-3 py-2 text-sm text-red-600", className)} data-sentry-component="MvarDerivedUnavailableNotice" data-sentry-source-file="MvarDerivedUnavailableNotice.tsx">
    <InfoIcon size={14} className="mt-0.5 shrink-0 text-red-600" data-sentry-element="InfoIcon" data-sentry-source-file="MvarDerivedUnavailableNotice.tsx" />
    <span>{message}</span>
  </div>;